export const TypesDetalheCarregaGate = {
    DETALHECARREGA: "DETALHECARREGA",
    RESETDETALHECARREGAGATE: "RESETDETALHECARREGAGATE",
    PREPARAOPERACAO: "PREPARAOPERACAO",
    GATE: "GATE",
    TIPOCARREGAMENTO: "TIPOCARREGAMENTO"
}

const INITIAL = {
    gateId: 0,
    empilhadeira: [],
    localOperacao: [],
    localSugestao: {},
    info: {},
    programacaoId: 0,

    Titulo: '',
    ItemViagemID: 0,
    Msg: '',
    OperacaoStatus: '',
    Placa: '',
    Nodes: [],

    carregamento: false
}

export default function detalheCarregaGateReducer(state = INITIAL, action) {

    switch (action.type) {
        case TypesDetalheCarregaGate.DETALHECARREGA:
            return {
                ...state,
                gateId: action.payload.gateId
            };
        case TypesDetalheCarregaGate.TIPOCARREGAMENTO:
            return {
                ...state,
                carregamento: action.payload.carregamento
            };
        case TypesDetalheCarregaGate.PREPARAOPERACAO:
            return {
                ...state,
                empilhadeira: action.payload.dados.empilhadeira,
                localOperacao: action.payload.dados.localOperacao,
                localSugestao: action.payload.dados.localSugestao,
                info: action.payload.dados.info,
                programacaoId: action.payload.ID

            };
        case TypesDetalheCarregaGate.GATE:
            return {
                ...state,
                Titulo: action.payload.Titulo,
                ItemViagemID: action.payload.ItemViagemID,
                Msg: action.payload.Msg,
                OperacaoStatus: action.payload.OperacaoStatus,
                Placa: action.payload.Placa,
                Nodes: action.payload.Nodes,
            };
        case TypesDetalheCarregaGate.RESETDETALHECARREGAGATE:
            return INITIAL;
        default:
            return state;
    }
}

export const DetalheCarregaGateActions = {
    detalheCarrega,
    resetStateDetalheCarrega,
    preparaOperacao,
    gate,
    tipoCarregamento
}

function detalheCarrega(pgateId) {

    return {
        type: TypesDetalheCarregaGate.DETALHECARREGA,
        payload: { gateId: pgateId }
    }
}

function preparaOperacao(dados, programacaoID) {

    return {
        type: TypesDetalheCarregaGate.PREPARAOPERACAO,
        payload: { dados: dados, ID: programacaoID }
    }
}

function gate(dados) {

    return {
        type: TypesDetalheCarregaGate.GATE,
        payload: dados
    }
}

function tipoCarregamento(value) {

    return {
        type: TypesDetalheCarregaGate.TIPOCARREGAMENTO,
        payload: { carregamento: value }
    }
}

function resetStateDetalheCarrega() {
    return { type: "RESETDETALHECARREGAGATE" }
}